import { X } from "lucide-react";

export default function HudModal({ open, title, onClose, children, testid }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose}>
      <div data-testid={testid} onClick={(e) => e.stopPropagation()} className="glass-card hud-corners w-full max-w-md p-6 bg-[#0a1628]/95">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-display text-sm font-bold text-cyan-300 tracking-widest uppercase text-glow-sm">{title}</h3>
          <button data-testid={`${testid}-close`} onClick={onClose} className="text-slate-400 hover:text-cyan-300">
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
